import { useParams, useSearchParams } from "react-router-dom";
import CharityService from "../../../services/CharityService";
import { Charity, CharityIssue } from "../../../models";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import Breadcrumbs from "../../../components/breadcrumbs";
import CharityEditForm from "./ui/charity-edit-form";
import CharitySkeleton from "./skeleton/charity-skeleton";
import CharityIssueCharityService from "../../../services/CharityIssueCharityService";
import CharityIssueCharityViewModel from "../../../viewModels/CharityIssueCharityViewModel";
import CharityIssueCharityTable from "./ui/charity-issue-charity-table";
import CharityIssueService from "../../../services/CharityIssueService";

export default function CharityEditPage(){
  const [searchParams] = useSearchParams();
     const { id } = useParams();
      const api = new CharityService();
      const apiCharityIssueCharity = new CharityIssueCharityService();
      const apiCharityIssue = new CharityIssueService();
      const [charityIssues, setCharityIssues] = useState<CharityIssue[]>([]);
      const [charityIssueCharities, setCharityIssueCharities] = useState<CharityIssueCharityViewModel[]>([]);
      const [charity, setCharity] = useState<Charity>();
      const [loading, setLoading] = useState(true);
      useEffect(() => { 
        fetchCharity();
        fetchCharityIssueCharities();
        fetchCharityIssues();
      }, [searchParams.get("reload")]);
      const fetchCharity = async () => {
        if (id) {
          const data = await api.getCharityById(parseInt(id));
          setCharity(data);
          setLoading(false);
          
        }
      };
      const fetchCharityIssueCharities = async () => {
        if (id) {
          const data = await apiCharityIssueCharity.getCharityIssueByCharity(parseInt(id));
          setCharityIssueCharities(data);
        }
      };
      const fetchCharityIssues = async () => {
        if (id) {
          const data = await apiCharityIssue.getCharityIssues();
          setCharityIssues(data);
        }
      };
      if (!charity && !loading) return <NotFound message="Charity not found." />;
    
      return (
        <main className="max-w-3xl ">
          <Breadcrumbs
            breadcrumbs={[
              { label: "Charities", href: "/admin/charities" },
              {
                label: "Edit",
                href: `/admin/charities/edit/${id}`,
                active: true,
              },
            ]}
          />
          {!loading && charity ? (<>
            <CharityEditForm charity={charity} />
            <CharityIssueCharityTable charityIssueCharities={charityIssueCharities} charityIssues={charityIssues} charity={charity} />
            
            </>
          ) : (
            <CharitySkeleton />
          )}
        </main>
      );
    }
